/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Luci_Shopping_Api_Models_OrderDetailModel } from './Luci_Shopping_Api_Models_OrderDetailModel';
export type Luci_Shopping_Api_Models_InvoiceDetailModel = {
  storeId?: number;
  solicitPayment?: boolean;
  solicitShipping?: boolean;
  order?: Luci_Shopping_Api_Models_OrderDetailModel;
  estimatedShippingTax?: number;
  estimatedSalesTax?: number;
  estimatedGrandTotal?: number;
  paymentDueDate?: string;
  /**
   * Completed or Paid order statuses should not show as expired.
   */
  readonly isExpired?: boolean;
   /**
   * Indicates if the invoice is past due but within the grace period.
   */
  readonly isPastDue?: boolean;
  /**
   * The tax strategy for the order.
   */
  taxStrategy?: Luci_Shopping_Api_Models_InvoiceDetailModel.taxStrategy;
  readonly isFreeOrder?: boolean;
};
export namespace Luci_Shopping_Api_Models_InvoiceDetailModel {
  /**
   * The tax strategy for the order.
   */
  export enum taxStrategy {
    NONE = 'None',
    CHARGE_TAX = 'ChargeTax',
    TAX_REIMBURSEMENT = 'TaxReimbursement',
  }
}

